import React, {Component} from 'react';
import ReactDOM from 'react-dom/client';
import PosInfo from "./general/PosInfo";
import 'bootstrap/dist/css/bootstrap.css'
import {Container} from "react-bootstrap";
import ReceiptExchangeList from "./general/ReceiptExchangeList";
import Operator from "./operator/Operator";
import InvalidReceiptList from "./general/InvalidReceiptList";
import './index.css'

class WebPages extends Component {
    state = {
        status: 'init',
        activeMenu: 'generalInfo',
        operatorName: "",
        operatorTin: "",
        version: ""
    }

    componentDidMount() {
        fetch('/rest/info').then(resp => {
            if (resp.ok) {
                this.setState({status: 'success'})
            } else if (resp.status === 503) {
                this.setState({status: 'generate'})
            } else {
                this.setState({status: 'failure'})
            }
        })
        fetch('/rest/info')
            .then(res => res.ok ? res.json() : Promise.reject())
            .then((result) => {
                console.log(result)
                this.setState({operatorName: result.operatorName, operatorTin: result.operatorTIN, version: result.version})
            })
    }

    handleMenuClick = (menuKey) => {
        this.setState({activeMenu: menuKey})
    }

    renderContent() {
        const {activeMenu} = this.state;

        switch (activeMenu) {
            case 'generalInfo':
                return <PosInfo/>;
            case 'invalidReceiptList':
                return <InvalidReceiptList/>;
            case 'exchangeList':
                return <ReceiptExchangeList/>;
            default:
                return <PosInfo/>;
        }
    }

    render() {
        if (this.state.status === 'success') {
            return (
                <>
                    <nav className="navbar navbar-expand-lg navbar-dark bg-primary ebarimt-header">
                        <div className="container-fluid px-4">
                            <a className="navbar-brand d-flex align-items-center" href="#">
                                <img src="img/ebarimt.png" height="40px"/>
                            </a>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#navbarNav">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarNav">
                                <ul className="navbar-nav me-auto gap-5" style={{marginLeft: '100px'}}>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${this.state.activeMenu === 'generalInfo' ? 'active' : ''}`}
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.handleMenuClick('generalInfo')
                                            }}
                                        >
                                            Ерөнхий мэдээлэл
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${this.state.activeMenu === 'invalidReceiptList' ? 'active' : ''}`}
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.handleMenuClick('invalidReceiptList')
                                            }}
                                        >
                                            Алдаатай баримт
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${this.state.activeMenu === 'exchangeList' ? 'active' : ''}`}
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.handleMenuClick('exchangeList')
                                            }}
                                        >
                                            Баримтын мэдээлэл солилцох сервис
                                        </a>
                                    </li>
                                </ul>
                                <span className="navbar-text text-white" style={{
                                    borderWidth: '1px',
                                    borderRadius: '10px',
                                    borderColor: 'limegreen',
                                    borderStyle: 'solid',
                                    padding: '6px'
                                }}>
                                    <strong>{this.state.operatorName}</strong> <span
                                    className="ms-2">{this.state.operatorTin}</span>
                                </span>
                                <span className="mx-3" style={{color: "white", fontWeight: "bold", fontSize: "14px"}}>{(this.state.version) || ''}</span>
                            </div>
                        </div>
                    </nav>
                    <div className="m-4">
                        {this.renderContent()}
                    </div>
                </>
            );
        } else if (this.state.status === 'generate') {
            return (
                <Container>
                    <Operator/>
                </Container>
            )
        } else if (this.state.status === 'failure') {
            return (
                <div className={'container mt-5'}>
                    <h2 className={'text-danger text-center'}>Unknown Error is occured!!!</h2>
                </div>
            )
        } else {
            return (
                <div className={'container mt-5'}>
                    <h2 className={'text-info text-center'}>Уншиж байна...</h2>
                </div>
            )
        }
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <WebPages/>
    </React.StrictMode>
);
